import HeroSection from "./hero-section";
import Companies from "./companies";
import ServicesShowcase2 from "./services-showcase";
import WritingServices from "./writing-services";
import ProfessionalGenres from "./professional-genres";
import ProofRibbon from "./proof-ribbon";
import Transformation from "./transformation";
import Bestsellers from "./bestsellers";
import AuthorsSpotlight from "./authors-spotlight";
import PartnersBand from "./partners-band";

export {
  HeroSection,
  Companies,
  ServicesShowcase2,
  WritingServices,
  ProfessionalGenres,
  ProofRibbon,
  Transformation,
  Bestsellers,
  AuthorsSpotlight,
  PartnersBand,
};
